export default __webpack_public_path__ + "static/media/Poppins-SemiBold.dbd42e23.woff";